import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from './SvgIcon';

var ArrowlineDown = function ArrowlineDown(props) {
  return _jsxs(SvgIcon, __assign({}, props, {
    children: [_jsx("path", {
      d: "M12.8 3.99995C12.8 3.55812 12.4418 3.19995 12 3.19995C11.5581 3.19995 11.2 3.55812 11.2 3.99995V14.5686L7.56564 10.9343C7.25322 10.6218 6.74669 10.6218 6.43427 10.9343C6.12185 11.2467 6.12185 11.7532 6.43427 12.0656L11.4343 17.0656C11.7467 17.3781 12.2532 17.3781 12.5656 17.0656L17.5656 12.0656C17.8781 11.7532 17.8781 11.2467 17.5656 10.9343C17.2532 10.6218 16.7467 10.6218 16.4343 10.9343L12.8 14.5686V3.99995Z"
    }), _jsx("path", {
      d: "M4.99995 19.2C4.55812 19.2 4.19995 19.5581 4.19995 20C4.19995 20.4418 4.55812 20.8 4.99995 20.8H19C19.4418 20.8 19.8 20.4418 19.8 20C19.8 19.5581 19.4418 19.2 19 19.2H4.99995Z"
    })]
  }));
};

export default ArrowlineDown;